module.exports = __webpack_public_path__ + "static/couture05-abe8e08648744271a1b9163a160cb7c3.png";